/*=========================================================================================
  File Name: moduleIndicatorGetters.js
  Description: Indicator Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	getIndicatorById: (state) => (indicatorId) => {
		return state.indicators.find((indicator) => indicator.id === indicatorId);
	},
};
